import { render, staticRenderFns } from "./patientTagSelectPop.vue?vue&type=template&id=6ff4b800&scoped=true&"
import script from "./patientTagSelectPop.vue?vue&type=script&lang=ts&"
export * from "./patientTagSelectPop.vue?vue&type=script&lang=ts&"
import style0 from "./patientTagSelectPop.vue?vue&type=style&index=0&id=6ff4b800&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff4b800",
  null
  
)

export default component.exports